module.exports = __webpack_public_path__ + "static/media/insitu_pro_edg_pro.5657a8a8.png";